import React from "react";
import styled from "styled-components";
import { Select } from "../../form/select/index";
import { Input } from "../../form/input/index";
import InputMask from "react-input-mask";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { Checkbox } from "../../form/checkbox/index";
import { AddTimeSlotIcon } from "../../icons/add-time-slot";
export const IconDelete = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
    React.createElement("path", { d: "M5.00063 14.0037C4.63384 14.0037 4.31975 13.873 4.05833 13.6116C3.79692 13.3502 3.66643 13.0363 3.66688 12.67V4.00062H3V2.66687H6.33437V2H10.3356V2.66687H13.67V4.00062H13.0031V12.67C13.0031 13.0368 12.8724 13.3509 12.611 13.6123C12.3496 13.8737 12.0357 14.0042 11.6694 14.0037H5.00063ZM11.6694 4.00062H5.00063V12.67H11.6694V4.00062ZM6.33437 11.3362H7.66813V5.33437H6.33437V11.3362ZM9.00187 11.3362H10.3356V5.33437H9.00187V11.3362Z", fill: "#4B4F5E" })));
export const IconCopyAlt = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
    React.createElement("path", { d: "M4.17647 13.7647C3.85294 13.7647 3.57588 13.6494 3.34529 13.4188C3.11471 13.1882 2.99961 12.9114 3 12.5882V4.35294H4.17647V12.5882H10.6471V13.7647H4.17647ZM6.52941 11.4118C6.20588 11.4118 5.92882 11.2965 5.69824 11.0659C5.46765 10.8353 5.35255 10.5584 5.35294 10.2353V3.17647C5.35294 2.85294 5.46824 2.57588 5.69882 2.34529C5.92941 2.11471 6.20627 1.99961 6.52941 2H11.8235C12.1471 2 12.4241 2.1153 12.6547 2.34588C12.8853 2.57647 13.0004 2.85333 13 3.17647V10.2353C13 10.5588 12.8847 10.8359 12.6541 11.0665C12.4235 11.2971 12.1467 11.4122 11.8235 11.4118H6.52941ZM6.52941 10.2353H11.8235V3.17647H6.52941V10.2353Z", fill: "#4B4F5E" })));
const Wrapper = styled.div `
  fontSize: 12px;
  table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
    border: 1px solid #e1e1e1;
  }

  th, td {
    padding: 12px;
    text-align: left;
    border: 1px solid #e1e1e1;
  }

  th {
    font-weight: 600;
    color: #4b4f5e;
    background-color: #f9f9f9;
	word-break: keep-all;
  }

  td {
    color: #4b4f5e;
    vertical-align: middle;
		@media (max-width: 576px) {
			 padding: 5px;
		}
  }
	td input select {
    padding: 0;
}
  select {
    border: none;
    outline: none;
    background-color: transparent;
    font-size: inherit;
  }

  input {
    border: none;
    outline: none;
    background-color: transparent;
    font-size: inherit;
  }

  .action-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  button {
    background: #f1f4f7;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 6px;
    cursor: pointer;
    transition: background-color 0.3s;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button:hover {
    background-color: #e1e7ed;
  }

  &.responsive {
	@media (max-width: 576px) {
		thead {
			display: none;
		}
		tbody {
			display: flex;
			flex-direction: column;
			tr {
				display: flex;
				flex-direction: column; 

				td {
					display: flex;
					align-items: center;
					gap: 8px;
				}
			}
		}
	}
  }
`;
const AddTimeSlotButtonStyle = styled.div `
  display: flex;
  width: 200px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dfdfdf;
  background: #f1f4f7;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-bottom: 20px;
  @media (max-width: 768px) {
       min-width: 60%;
	   align-items: center;
    }
  
  &:hover {
    background-color: #e1e7ed;
  }
`;
const Days = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
];
export class FieldOpeningHoursV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localHours: [...props.hours || []],
            activeIndex: -1,
        };
    }
    handleLocalChange = (index, key, value) => {
        const localHours = [...this.state.localHours];
        localHours[index][key] = value;
        this.setState({ localHours });
        this.props.onChange(localHours);
    };
    add = () => {
        const localHours = [
            ...this.state.localHours,
            { day: "Monday", open: "09:00", close: "21:00", h24: false },
        ];
        this.setState({ localHours });
        this.props.onChange(localHours);
    };
    copy = (index) => {
        const localHours = [...this.state.localHours];
        const hour = { ...localHours[index] };
        localHours.push(hour);
        this.setState({ localHours });
        this.props.onChange(localHours);
    };
    remove = (index) => {
        const localHours = [...this.state.localHours];
        localHours.splice(index, 1);
        this.setState({ localHours });
        this.props.onChange(localHours);
    };
    onUp = (index) => {
        const { localHours } = this.state;
        if (index > 0) {
            const updatedHours = [...localHours];
            [updatedHours[index - 1], updatedHours[index]] = [updatedHours[index], updatedHours[index - 1]];
            this.setState({ localHours: updatedHours, activeIndex: index - 1 });
            this.props.onChange(updatedHours);
        }
    };
    onDown = (index) => {
        const { localHours } = this.state;
        if (index < localHours.length - 1) {
            const updatedHours = [...localHours];
            [updatedHours[index + 1], updatedHours[index]] = [updatedHours[index], updatedHours[index + 1]];
            this.setState({ localHours: updatedHours, activeIndex: index + 1 });
            this.props.onChange(updatedHours);
        }
    };
    componentDidUpdate(prevProps) {
        if (prevProps.hours !== this.props.hours) {
            this.setState({ localHours: [...(this.props.hours || [])] });
        }
    }
    render() {
        const { localHours } = this.state;
        return (React.createElement(Wrapper, { className: this.props.className },
            React.createElement(AddTimeSlotButtonStyle, { onClick: this.add },
                React.createElement(AddTimeSlotIcon, null),
                " Add Time Slot"),
            React.createElement("table", { style: { fontSize: '12px' } },
                localHours.length > 0 && React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Day"),
                        React.createElement("th", null, "Open"),
                        React.createElement("th", null, "Close"),
                        React.createElement("th", null, "24 Hrs."),
                        React.createElement("th", null, "Action"))),
                React.createElement("tbody", null, localHours.map((h, index) => (React.createElement("tr", { key: index },
                    React.createElement("td", null,
                        React.createElement(Select, { options: Days, value: h.day, onChange: (e) => this.handleLocalChange(index, "day", e.target.value) })),
                    React.createElement("td", null,
                        React.createElement(InputMask, { mask: "99:99", value: h.open, onChange: (e) => this.handleLocalChange(index, "open", e.target.value), disabled: h.h24 }, (inputProps) => React.createElement(Input, { type: "text", placeholder: "00:00", ...inputProps, disabled: h.h24 }))),
                    React.createElement("td", null,
                        React.createElement(InputMask, { mask: "99:99", value: h.close, onChange: (e) => this.handleLocalChange(index, "close", e.target.value), disabled: h.h24 }, (inputProps) => React.createElement(Input, { type: "text", placeholder: "00:00", ...inputProps, disabled: h.h24 }))),
                    React.createElement("td", null,
                        React.createElement(Checkbox, { id: `${index}-24-hours-checkbox`, checked: h.h24, className: "centered-checkbox", onChange: (e) => this.handleLocalChange(index, "h24", e.target.checked) })),
                    React.createElement("td", { className: "action-buttons" },
                        React.createElement("button", { type: "button", onClick: () => this.onUp(index) },
                            React.createElement(FaArrowUp, { className: "icon" })),
                        React.createElement("button", { type: "button", onClick: () => this.onDown(index) },
                            React.createElement(FaArrowDown, { className: "icon" })),
                        React.createElement("button", { type: "button", onClick: () => this.copy(index) },
                            React.createElement(IconCopyAlt, null)),
                        React.createElement("button", { type: "button", onClick: () => this.remove(index) },
                            React.createElement(IconDelete, null))))))))));
    }
}
//# sourceMappingURL=opening_hours_v2.js.map